module.exports = __webpack_public_path__ + "static/img/XMWTTU.d6495ea3.jpg";